// extracted by mini-css-extract-plugin
export default {"trxRoomWrapper":"styles_trxRoomWrapper__dlLjY","confettiBlue":"styles_confettiBlue__-OVCS","orange":"styles_orange__+fFLE","white":"styles_white__Q2GVC"};